import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';

import { ServiceAreaSuggestionResult } from './__generated__/service-area-suggestion-graphql.service.types';

@Injectable({
  providedIn: 'root',
})
export class ServiceAreaSuggestionGraphQL extends Query<ServiceAreaSuggestionResult> {
  document = gql`
    query ServiceAreaSuggestion {
      suggestedServiceArea {
        serviceArea {
          id
          code
          name
          virtual
        }
      }
    }
  `;
}
